<template>
  <div>
    <general-table
      ref="countriesTable"
      :api-url="apiUrl"
      :delete-content="true"
      :block-content="false"
      :edit-content="false"
      :view-content="false"
      :columns="columns"
      :type="type"
    >
      <template #cell(approved)="data">
        <slot
          name="show"
          v-bind="data"
        >
          <div class="text-center">
            <span
              v-if="data.item.approved === 1"
              style="border-radius: 10%; padding: 6px;"
            >
              <feather-icon
                icon="CheckIcon"
                size="15"
                color="blue"
              />
            </span>

            <span
              v-else
              style=" border-radius: 10%; padding: 6px;"
            >
              <feather-icon
                icon="XIcon"
                size="15"
                color="red"
              />
            </span>
          </div>
        </slot>
      </template>
      <template #cell(show_info_service)="data">
        <slot
          name="info"
          v-bind="data"
        >
          <div class="text-center">
            <span title="View">
              <feather-icon
                icon="EyeIcon"
                class="cursor-pointer"
                @click="
                  $router.push({
                    name: 'service-show',
                    params: { id: data.item.id }
                  })
                "
              />
            </span>
          </div>
        </slot>
      </template>
    </general-table>
  </div>
</template>

<script>
import GeneralTable from '@/components/general-table/GeneralTable.vue'

export default {
  components: { GeneralTable },
  data() {
    return {
      APIURL: 'service',
      // addType: 'Add City',
      // addComponentName: 'add-city',
      // editComponent: 'edit-city',
      // viewContent: true,
      type: 'page',
      partners: [],
      filter: {},
      types: '',
      columns: [
        { key: 'id', sortable: true },
        { key: 'name', label: 'Name' },
        { key: 'description', label: 'Description' },
        { key: 'days_require', label: 'Days Require' },
        { key: 'location', label: 'Location' },
        { key: 'estimate_money', label: 'Estimate Money' },
        { key: 'approved', label: 'Approved' },
        { key: 'description', label: 'Description' },
        { key: 'show_info_service', label: 'Show Info' },
        { key: 'actions' },
      ],
    }
  },

  computed: {
    apiUrl() {
      let base = 'service?'

      if (!Object.values(this.filter).length) {
        return base.slice(0, -1)
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.filter)) {
        if (key && value) {
          base += `${key}=${value}&`
        }
      }
      // console.log(base.slice(0, -1))
      return base.slice(0, -1)
    },
  },
  // mounted() {
  //   console.log('Count in mounted:', this.role)
  // },

  methods: {
    filterTypes(type) {
      const filteredType = this.status.filter(item => item.text !== type)
      this.types = filteredType
    },
  },
}
</script>

<style></style>
